export default __webpack_public_path__ + "static/media/03.d3eb7346.jpg";